import { combineReducers } from 'redux';
import { filterReducer } from 'redux/marketPrice/filter';
import { tableReducer } from 'redux/marketPrice/table';
import { addSurveyReducer } from 'redux/marketPrice/addSurvey';
import { addSurveyFilterReducer } from 'redux/marketPrice/addSurveyFilter';
import { addSurveySortingReducer } from 'redux/marketPrice/addSurveySorting';
import { sortingReducer } from 'redux/marketPrice/sorting';
import { currencyPlanReducer } from 'redux/marketPrice/currencyPlan';
import { compositesReducer } from 'redux/marketPrice/composites';
import { cutsReducer } from 'redux/marketPrice/cuts';

export const marketPriceReducer = combineReducers({
  table: tableReducer,
  filter: filterReducer,
  addSurvey: addSurveyReducer,
  addSurveyFilter: addSurveyFilterReducer,
  addSurveySorting: addSurveySortingReducer,
  sorting: sortingReducer,
  currencyPlan: currencyPlanReducer,
  composites: compositesReducer,
  cuts: cutsReducer,
});
